import { LabelValueModel } from './labelValue.model';
import { Pipe } from "@angular/core";
import { FieldModel } from "./field.model";

export class FieldGroupModel {

    public label: string;
    public id: string;
    public fields: FieldModel[];
    public type: string;
    public classes: string;

    public hidden: boolean;
    public toggleVisibilityOn: string;
    public toggleVisibleWhen: string; //look for a value
    public editLink: boolean;
	public singleColumn: boolean = false;

    constructor(label: string, id: string = null, classes: string="", type: string = "standard") {
        this.label = label;
        this.id = id || label;
        this.type = type;
        this.fields = [];
        this.classes = classes;
    }

    public addField(field: FieldModel): number {
        return this.fields.push(field);
    }
}
